$(function () {
  /************* タブ初期化 *************/
  var $tabs = $(".lp-item__nav-list .js-tab"); // li.js-tab（a ではなく li 自体に .js-tab）
  if (!$tabs.length) return;

  var $initial = $tabs.filter(".is-current");
  if (!$initial.length) $initial = $tabs.first().addClass("is-current");

  function showContentByTarget(targetId) {
    $(".js-content").removeClass("is-current").hide();
    $("#" + targetId).addClass("is-current").show();
  }
  showContentByTarget($initial.data("target"));

  /************* タブ切り替え *************/
  $tabs.on("click", function () {
    $tabs.removeClass("is-current");
    var $t = $(this).addClass("is-current");
    var targetId = $t.data("target");
    showContentByTarget(targetId);
    ensureModelSelect($("#" + targetId));           // セレクト未生成なら作る
    loadAllListsForContent($("#" + targetId));      // 5リストを読み込み
  });

  $(".tab-buttons__next").on("click", function () {
    var $cur = $tabs.filter(".is-current");
    var $next = $cur.nextAll(".js-tab").first();
    if ($next.length) $next.trigger("click");
  });
  $(".tab-buttons__prev").on("click", function () {
    var $cur = $tabs.filter(".is-current");
    var $prev = $cur.prevAll(".js-tab").first();
    if ($prev.length) $prev.trigger("click");
  });

  /************* 5つのリストをまとめてロード *************/
  async function loadAllListsForContent($content, selectedTag) {
    const $lists = $content.find(".lp-item__list[data-collection-url]");
    if (!$lists.length) return;

    for (let i = 0; i < $lists.length; i++) {
      await loadOneList($($lists[i]), $content, selectedTag);
    }
  }

  async function loadOneList($list, $content, selectedTag) {
    const baseUrl = $list.attr("data-collection-url");
    const handle  = $list.attr("data-collection-handle");
    if (!baseUrl || !handle) return;

    // 機種タグ選択時のURL切替（任意のシリーズは /collections/all-case/<tag> へ）
    const allCaseHandles = ["series-iphone","series-android","xperia-series","galaxy-series","pixel-series","xiaomi-series","motorola-series"];
    let url = baseUrl;
    if (selectedTag) {
      url = allCaseHandles.includes(handle)
        ? `/collections/all-case/${selectedTag}`
        : `/collections/${handle}/${selectedTag}`;
    }

    $list.html('<div class="collection-loading">読み込み中...</div>');

    try {
      const res = await fetch(url, { credentials: "same-origin" });
      if (!res.ok) throw new Error("Fetch failed: " + url);

      const text = await res.text();
      const doc  = new DOMParser().parseFromString(text, "text/html");

      // テーマ差異を吸収
      const grid =
        doc.querySelector(".collection.grid") ||
        doc.querySelector("#product-grid") ||
        doc.querySelector('[data-id="product-grid"]') ||
        doc.querySelector(".collection__products");

      let html = "";
      if (grid) {
        const items = Array.from(grid.querySelectorAll(".product-item"));
        const empty = grid.querySelector(".collection-empty");
        if (items.length) html = items.map((el) => el.outerHTML).join("");
        else html = empty ? empty.outerHTML : grid.innerHTML;
      } else {
        html = '<div class="collection-empty">商品が見つかりませんでした。</div>';
      }

      $list.html(html);

      // ▼ 見た目の後処理（既存仕様）
      const showTitle = $content.attr("data-show-title") === "true";
      const showPrice = $content.attr("data-show-price") === "true";

      // タイトル整形
      $list.find(".product-slideShow-title").each(function () {
        const t = $(this).text();
        const m = t.match(/.*?-([\s\S]*)/);
        if (m && m[1]) $(this).text(m[1].trim());
      });

      if (showTitle) {
        $list.find(".product-slideShow-title").css({ display: "block", textAlign: "center" });
      }
      if (showPrice) {
        $list.find(".product-slideShow-price").css({ display: "block" });
      }

      // freeword タグ表示
      $list.find(".product-item").each(function () {
        const $item = $(this);
        const tagsAttr = $item.attr("data-product-tags");
        if (!tagsAttr) return;
        try {
          const decoded = tagsAttr.replace(/&quot;/g, '"');
          const tags = JSON.parse(decoded);
          const fw = tags.filter((t) => t.startsWith("freeword_"));
          if (fw.length) {
            const $w = $('<div class="product-slideShow-freeword-list"></div>');
            fw.forEach((t) => $w.append(
              $('<span class="product-slideShow-freeword-tag"></span>').text(t.replace("freeword_", ""))
            ));
            $item.append($w);
          }
        } catch (e) { console.error("freeword解析失敗:", e); }
      });

    } catch (e) {
      console.error(e);
      $list.html('<div class="collection-empty">読み込みでエラーが発生しました。</div>');
    }
  }

  /************* 機種セレクト：タブ毎に生成、全リストへ反映 *************/
  function ensureModelSelect($content) {
    const $box = $content.find(".manufacturer_selector");
    if (!$box.length) return;
    if ($box.find(".model-select").length) return; // 既にある

    const $sel = $('<select class="model-select"><option value="" disabled selected>機種選択</option></select>');
    $box.append($sel);

    var currentTag  = "{{current_tags}}";
    var modelGroups = window.fox?.settings?.model_groups_checkbox || [];

    function addOpt(code, label) {
      $sel.append(`<option value="mo_${code}">${label}</option>`);
      if (currentTag.match(`mo_${code}`)) $sel.addClass("add_check");
    }

    modelGroups.forEach((g) => {
      (g.code_sort || []).forEach((code) => {
        if (/AP/.test(code)) addOpt(code, `${window.fox.settings.model[code]} (iPhone)`);
        else addOpt(code, `${window.fox.settings.model[code]} (Android)`);
      });
    });

    $sel.on("change", function () {
      const tag = $(this).val();
      loadAllListsForContent($content, tag); // 現タブ内の5リストを全て再取得
    });
  }

  // 初回：最初のタブのセレクト生成＆5リスト読込
  ensureModelSelect($("#" + $initial.data("target")));
  loadAllListsForContent($("#" + $initial.data("target")));
});